export default __webpack_public_path__ + "static/media/IMG_2564.bc827fe5.jpg";